import React, { useEffect } from 'react'
import '../stylesheets/createStudy.scss'
import PropTypes from 'prop-types'
import STRINGS from 'utils/strings'

import CreateStudyNav from './CreateStudyNav'

const CreateStudyPage = props => {
  const {
    children,
    disabled,
    isRootOrDchAdmin,
    isWizard,
    resetStudyData,
    setNavBarProps,
    fetchLocales,
  } = props

  useEffect(() => {
    if (!disabled || isWizard) {
      resetStudyData(isRootOrDchAdmin)
    }
    if (!disabled && !isWizard) {
      setNavBarProps({
        back: '/studies',
        backText: STRINGS.studies,
        close: '/studies',
      })
    }
    if (fetchLocales) fetchLocales()
    return () => {
      setNavBarProps(null)
    }
  }, [])

  return (
    <div className='create-study page'>
      <CreateStudyNav {...props} />
      {children}
    </div>
  )
}

CreateStudyPage.propTypes = {
  children: PropTypes.node,
  createStudy: PropTypes.func,
  deleteStudy: PropTypes.func,
  disabled: PropTypes.bool,
  fetchLocales: PropTypes.func,
  hasDeleteStudyPermissions: PropTypes.bool,
  isRootOrDchAdmin: PropTypes.bool,
  isWizard: PropTypes.bool,
  resetStudy: PropTypes.func,
  resetStudyData: PropTypes.func,
  saveAttempted: PropTypes.bool,
  setNavBarProps: PropTypes.func,
  study: PropTypes.shape({
    self_sign_code: PropTypes.string,
    name: PropTypes.string,
    platform_name: PropTypes.string,
    id: PropTypes.number,
  }),
  updateConfig: PropTypes.func,
  updateStudy: PropTypes.func,
}

export default CreateStudyPage
